import { render, staticRenderFns } from "./PresentationBoardCard.vue?vue&type=template&id=7674dbf3&scoped=true&"
import script from "./PresentationBoardCard.vue?vue&type=script&lang=js&"
export * from "./PresentationBoardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674dbf3",
  null
  
)

export default component.exports